import React from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from 'styled-components'
import { Cropfree } from '@dsny/dsny-component-library/icons'
import { ExpandButton } from '../../ReleaseInformation.styles'
import useReleaseInformationResponsiveBreakpointsV2 from '../../hooks/useReleaseInformationResponsiveBreakpointsV2'

type CoverArtPreviewProps = {
  onExpand: (event: React.MouseEvent<HTMLButtonElement>) => void
}

export default function CoverArtPreview({ onExpand }: CoverArtPreviewProps) {
  const theme = useTheme()
  const { t } = useTranslation()
  const responsiveBreakpointsV2 = useReleaseInformationResponsiveBreakpointsV2()

  return (
    <ExpandButton
      $responsiveBreakpointsV2={responsiveBreakpointsV2}
      aria-label={t('release-info.expand-cover-art')}
      type="button"
      onClick={onExpand}>
      <Cropfree color={theme.colors.neutralW100} height={22} width={22} />
    </ExpandButton>
  )
}
